import type { RouteObject } from 'react-router-dom';
import AccountSettingsPage from '../pages/AccountSettingsPage';
import BlockedPeoplePage from '../pages/BlockedPeoplePage';
import ConnectionsPage from '../pages/ConnectionsPage';
import MutedCollectionsPage from '../pages/MutedCollectionsPage';
import NotificationSettingsPage from '../pages/NotificationSettingsPage';
import SignUpPage from '../pages/SignUpPage';
import { OPEN_TO_SIGNED_OUT } from './signedOut';

export const accountRoutes: RouteObject[] = [
  { path: '/settings/account', element: <AccountSettingsPage /> },
  { path: '/settings/connections', element: <ConnectionsPage /> },
  { path: '/settings/muted', element: <MutedCollectionsPage /> },
  { path: '/settings/blocked', element: <BlockedPeoplePage /> },
  { path: '/settings/notifications', element: <NotificationSettingsPage /> },
  { path: '/sign-up', element: <SignUpPage />, handle: OPEN_TO_SIGNED_OUT },
];
